import {HumidifierActionTypes} from 'constants/actionType';

const initialState = {
  isHumidifierInstalled: false,
  idleHumidity: '',
  isIdleHumidityEnabled: false,
  humidifierDoorStatus: null,
  isWaterLevelLow: null,
  humidifierRuntime: {
    ambientHumidity: null,
    ambientTemperature: null,
    chamberHumidity: null,
    chamberTemperature: null,
    isBelowSetPoint: false,
  },
  humidifierError: '',
  isHumidifierConnected: false,
};

const humidifierState = (state = initialState, action = '') => {
  switch (action.type) {
    case HumidifierActionTypes.SET_IS_HUMIDIFIER_INSTALLED:
      return {...state, isHumidifierInstalled: action.data};
    case HumidifierActionTypes.SET_IDLE_HUMIDITY:
      return {...state, idleHumidity: action.data};
    case HumidifierActionTypes.SET_IS_IDLE_HUMIDITY_ENABLED:
      return {...state, isIdleHumidityEnabled: action.data};
    case HumidifierActionTypes.SET_HUMIDIFIER_DOOR_STATUS:
      return {...state, humidifierDoorStatus: action.data};
    case HumidifierActionTypes.SET_HUMIDIFIER_RUNTIME:
      return {...state, humidifierRuntime: action.data};
    case HumidifierActionTypes.SET_HUMIDIFIER_ERROR:
      return {...state, humidifierError: action.data};
    case HumidifierActionTypes.SET_IS_WATER_LEVEL_LOW:
      return {...state, isWaterLevelLow: action.data};
    case HumidifierActionTypes.SET_IS_HUMIDIFIER_CONNECTED:
      return {...state, isHumidifierConnected: action.data};
    default:
      return state;
  }
};

export default humidifierState;
